const featureFlags = {
    shortApp: 'SWED-8251-add-shortened-application-feature-flag',
    newPowersportsApp: 'BLUR-486-enable-new-powersports-application',
    selfServiceManagement: 'CSP-1740-add-self-service-management-feature-flag',
    leadsPage: 'ROGUE-270-enable-leads-page-for-dealer-portal',
    webAppLoyaltyDashboard:
        'CSP-1875-migrate-loyalty-dashboard-from-old-to-new-dealer-portal',
    customerEligibilityEnabledForAutoApps:
        'SHOCK-67-enable-state-eligibility-for-automobile-applications',
    payOff10Days: 'ZEN-468-10-days-pay-off-navigation',
    newWtdPath: 'ABBA-1454-determine-wtd-path',
    flatCancel: 'ZEN-619-flat-cancel-button-feature-flags',
    documentViewerForStips:
        'SHOCK-247-enable-document-viewer-for-stips-on-dealer-portal',
    dealTermsTableFiltering: 'BLUR-459-add-filters-to-available-deal-terms',
    dealTermsTable:
        'ABBA-1974-show_new_terms_table_in_work_the_deal_for_powersport_and_rv',
    showNewSafeCheckPage: 'ABBA-2032-new-safecheck-report-page',
    showFlexLink: 'DITTO-690-show-flex-link-homepage',
    dynamicPricing: 'DP-6-enable-dynamic-pricing',
    tradeInAdjustment: 'LP-16-enable-trade-in-adjustment',
    returnCustomerPsApp2: 'FIKA-2643-return-customer-ps-app-2-0',
}

export default featureFlags
